<div class="text-center bg-white py-5">
    <i class="fas text-primary fa-check-double fa-10x mb-3"></i>
    
    <h4 class="mb-0 text-primary">{{ message}}</h4>
</div>